import React from "react";
import { object } from "prop-types";
import get from "lodash/get";

import "./live-blog-timestamp.m.css";

const LiveBlogTime = ({ card }) => {
  const timeStamp = card["card-added-at"];
  const isKeyEvent = get(card, ["metadata", "attributes", "key-event"], false);

  const getLiveBlogCardTime = (timestamp) => {
    const opts = {
      timeZone: "Asia/Calcutta",
    };
    return `${new Date(timestamp).toLocaleString("en-US", {
      ...opts,
      hour: "numeric",
      minute: "numeric",
    })} ,
    ${new Date(timestamp).toLocaleString("en-US", {
       ...opts, day: "2-digit" }
    )}
    ${new Date(timestamp).toLocaleString("en-US", {
      ...opts,
      month: "short",
    })}`;
  };

  return (
    <div styleName="wrapper">
      <div styleName={`text timestamp ${isKeyEvent ? "with-event" : ""}`}>
        {getLiveBlogCardTime(timeStamp)}
      </div>
      {isKeyEvent && <div styleName="text event">KEY EVENT</div>}
    </div>
  );
};

LiveBlogTime.propTypes = {
  card: object,
};

export default LiveBlogTime;
